export const COMMUNITY_PROJECT_ID = 'c635af4b-5e32-4d42-98a1-994108710141'
export const VIEW_MODE_KEY = 'morta-hubs-view-mode'

export interface PinnedHub {
  name: string
  abbreviation: string
  publicId: string
  backgroundColor: string
}

export const pinnedHubs: PinnedHub[] = [
  {
    name: 'Morta Community Templates',
    abbreviation: 'Te',
    publicId: 'd13ea76b-e01c-46dd-8085-42b6f99a7aaa',
    backgroundColor: '#3d80fc'
  },
  {
    name: 'Morta Community',
    abbreviation: 'Co',
    publicId: 'c635af4b-5e32-4d42-98a1-994108710141',
    backgroundColor: '#3d80fc'
  },
  {
    name: 'Information Management Initiative Framework',
    abbreviation: 'IMI',
    publicId: 'a690e3a3-aa56-4a14-bb59-887f9c743b31',
    backgroundColor: '#084c9c'
  }
]
